import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { MatchTable } from '../match-table.model';

@JsonObject('MatchsResultsResponse')
export class MatchsResultsResponse extends ApiResultsResponse<MatchTable> {

  @JsonProperty('results', [MatchTable])
  override results: MatchTable[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
